import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {Redirect, Route} from 'react-router-dom'

import * as userSelectors from '../store/user'
import * as URLS from '../urls'

import CustomPropTypes from '../customPropTypes'

/**
 * Use this wrapper around React Router's `<Route />` component to automatically
 * redirect users to the static login page if they are un-authenticated. That login
 * form will then redirect back to the location that this Route matched and rendered for.
 *
 * @see [React Router Example](https://reactrouter.com/web/example/auth-workflow)
 */
const PrivateRoute = ({
  children,
  exact,
  isAuthenticated,
  isUserAndEventPending,
  location,
  path,
  sensitive,
  strict,
}) => (
  <Route
    exact={exact}
    location={location}
    path={path}
    sensitive={sensitive}
    strict={strict}
    render={(routeProps) => {
      if (isUserAndEventPending) {
        return null
      }
      if (isAuthenticated) {
        return children
      }
      return (
        <Redirect
          to={{
            pathname: URLS.STATIC_LOGIN,
            state: {
              from: routeProps.location.pathname,
            },
          }}
        />
      )
    }}
  />
)

PrivateRoute.propTypes = {
  children: CustomPropTypes.children,
  exact: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  isUserAndEventPending: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string,
    key: PropTypes.string,
    pathname: PropTypes.string,
    search: PropTypes.string,
    state: PropTypes.shape({}),
  }),
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  sensitive: PropTypes.bool,
  strict: PropTypes.bool,
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: userSelectors.isAuthenticated,
  isUserAndEventPending: userSelectors.isUserAndEventPending,
})

export default connect(mapStateToProps)(PrivateRoute)
